module.exports = __webpack_public_path__ + "img/gal_30.596b48d7.png";